var _circle, _circle2, _circle3, _circle4, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 2,
    r: 1.5,
    stroke: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 8,
    r: 1.5,
    stroke: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 5,
    r: 1.5,
    stroke: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 14,
    r: 1.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "m3.254 8.866 7.453 4.391M2.6 6.7l3-4M8.411 2.538l4.469 1.86M13.706 6.613l-1.375 5.937M7.618 3.419l3.75 9.093"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModel);
export default __webpack_public_path__ + "static/media/model.6b0869c3.svg";
export { ForwardRef as ReactComponent };